import { FormRow, socialLinksPrefixes } from 'framework';
import { TextInput } from 'dbi-pearl-ui-kit';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { SocialLinksSectionStyled } from './SocialLinksSectionNew.styled';
import { useTranslation } from 'react-i18next';
import TooltipComponent from 'vendor/components/Utility/TooltipComponent/TooltipComponent';
const socials = ['Website'];

const SocialLinksSection = ({ crawledVendorWebsite = '' }) => {
    const { watch, getValues, setValue } = useFormContext();
    const { t } = useTranslation();
    const [currentTarget, setCurrentTarget] = useState(null);
    const [websiteFieldName] = [...socials];

    const cleanLink = (name, url) => {
        if (!url) return;

        const stripped = url.replace(/(^\w+:|^)\/\//, '');

        const domainOnly = stripped.match(/^([a-zA-Z0-9.-]+\.[a-z]{2,})/);
        const cleaned = domainOnly ? domainOnly[1] : stripped;

        if (name === websiteFieldName) {
            return cleaned;
        }

        return url;
    };

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            setCurrentTarget(name);
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (currentTarget) {
            if (socials.includes(currentTarget)) {
                setValue(currentTarget, cleanLink(currentTarget, getValues(currentTarget)));
            }
        }
    }, [watch(currentTarget)]);

    useEffect(() => {
        if (crawledVendorWebsite) {
            const cleaned = cleanLink(websiteFieldName, crawledVendorWebsite);
            setValue(websiteFieldName, cleaned, { shouldValidate: true });
        }
    }, [crawledVendorWebsite]);

    return (
        <SocialLinksSectionStyled data-testid="social-links-section">
            <div className="link-row">
                <FormRow
                    className="websiteField"
                    data-testid="website-link"
                    columns={[
                        <div>
                            <TextInput
                                formFieldName={websiteFieldName}
                                preText={socialLinksPrefixes.website.displayText}
                                providedLabel={t(`Forms.BusinessInformation.WebsiteTitle`)}
                            ></TextInput>
                        </div>,
                    ]}
                />
                <div className="tooltipWebsite">
                    <TooltipComponent
                        showCloseButton={false}
                        header={''}
                        width={'291'}
                        height={'95'}
                        bottomSmall={'148'}
                        leftSmall={'-610'}
                        arrowBottomSmallscreen={'-21'}
                        arrowLeftSmallscreen={'91'}
                        arrowBottom={'-22'}
                        arrowLeft={'90'}
                        bottom={'148'}
                        left={'-605'}
                        content={t(`Forms.BusinessInformation.SocialTooltip`)}
                    />
                </div>
            </div>
        </SocialLinksSectionStyled>
    );
};

export { SocialLinksSection };
